import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  fr: {
    translation: {
      // Navigation
      "nav.home": "Accueil",
      "nav.services": "Services",
      "nav.panneaux": "Panneaux",
      "nav.coordination": "Coordination",
      "nav.testimonials": "Avis clients",
      "nav.faq": "FAQ",
      "nav.contact": "Contact",
      "nav.blog": "Blog",
      "nav.language": "NL",
      "nav.cta": "Prendre rendez‑vous",

      // Blog Section
      "blog.title": "Notre Blog Énergie",
      "blog.description": "Découvrez nos articles, conseils et actualités sur l'énergie solaire et les économies d'énergie",
      "blog.meta.title": "Blog Énergie Solaire et Économies",
      "blog.meta.description": "Articles et conseils d'experts sur l'énergie solaire, les économies d'énergie et les innovations du secteur",
      "blog.meta.keywords": "énergie solaire, panneaux solaires, économies énergie, blog énergie",
      "blog.readMore": "Lire la suite",
      "blog.backToBlog": "Retour au blog",
      "blog.share": "Partager",
      "blog.contactUs": "Nous contacter",
      
      // Hero Section
      "hero.title": "Payez moins cher votre énergie à <span class=\"highlight\">Bruxelles</span>, en <span class=\"highlight\">Brabant flamand</span> et <span class=\"highlight\">Brabant wallon</span>",
      "hero.subtitle": "Jusqu'à <strong>40% d'économies</strong> : comparaison multi-fournisseurs, changement sans coupure en 30 min.",
      "hero.cta": "Réserver ma simulation gratuite",
      "hero.guarantee1.title": "100% gratuit",
      "hero.guarantee1.description": "Aucun frais caché",
      "hero.guarantee2.title": "Sans engagement",
      "hero.guarantee2.description": "Liberté totale",
      "hero.guarantee3.title": "Réponse sous 24h",
      "hero.guarantee3.description": "Service réactif",
      "hero.stats.savings.percentage": "40%",
      "hero.stats.savings.label": "d'économies moyennes",
      "hero.stats.providers.number": "25+",
      "hero.stats.providers.label": "fournisseurs comparés",
      "hero.stats.time.number": "30min",
      "hero.stats.time.label": "pour votre simulation",
      "hero.scroll.text": "Découvrez nos services",
      
      // FAQ Section
      "faq.title": "FAQ Contrats d'énergie (Belgique)",
      "faq.subtitle": "Tout ce que vous devez savoir sur nos services",
      "faq.q1.question": "Quels types d'énergie proposez-vous ?",
      "faq.q1.answer": "Électricité et gaz naturel pour particuliers et PME, y compris des offres 100 % vertes.",
      "faq.q2.question": "Le service est-il vraiment 100% gratuit ?",
      "faq.q2.answer": "Oui, notre service est entièrement gratuit. Nous ne facturons aucun frais caché.",
      "faq.q3.question": "Y a-t-il des frais cachés ?",
      "faq.q3.answer": "Non, aucun frais caché. Notre service est 100% gratuit, sans engagement.",
      "faq.q4.question": "Puis-je changer de fournisseur à tout moment ?",
      "faq.q4.answer": "Oui, gratuitement et sans coupure : la loi belge le permet.",
      "faq.q5.question": "Quel est le délai pour changer ?",
      "faq.q5.answer": "En général 2 à 3 semaines ; vous choisissez la date de démarrage.",
      "faq.q6.question": "Quelles infos faut-il fournir ?",
      "faq.q6.answer": "Code EAN, adresse, relevé d'index, IBAN.",
      "faq.q7.question": "Prix fixe ou variable ?",
      "faq.q7.answer": "Les deux existent ; nous vous aidons à choisir la formule la plus avantageuse.",
      "faq.q8.question": "Puis-je résilier quand je veux ?",
      "faq.q8.answer": "Oui, sans indemnité : il suffit de souscrire ailleurs.",
      "faq.q9.question": "Que faire en cas de déménagement ?",
      "faq.q9.answer": "Prévenez-nous 10 jours à l'avance ; nous transférons ou créons un nouveau contrat.",
      "faq.q10.question": "Proposez-vous de l'électricité verte ?",
      "faq.q10.answer": "Oui, issue de sources renouvelables certifiées.",
      "faq.q11.question": "Comment joindre le service client ?",
      "faq.q11.answer": "Téléphone : +32 2 123 45 67 – E-mail : contact@bravo-energy.be.",
      "faq.q12.question": "Êtes-vous reconnus par les autorités ?",
      "faq.q12.answer": "Oui : CREG, Brugel, CWAPE et VREG.",
      
      // Contact Section
      "contact.title": "Réservez votre rendez-vous gratuit",
      "contact.subtitle": "Bruxelles • Brabant flamand • Brabant wallon",
      "contact.subtitle2": "Visio ou visite sur site – réponse sous 24 h.",
      "contact.info.title": "Contact rapide",
      "contact.info.description": "Une question ? Envoyez-nous un message et nous vous répondrons rapidement.",
      "contact.email.label": "Email",
      "contact.phone.label": "Téléphone",
      "contact.address.label": "Adresse",
      "contact.form.title": "Simulation gratuite",
      "contact.form.subtitle": "Remplissez ce formulaire pour recevoir votre simulation personnalisée sous 24h.",
      "contact.form.name": "Nom complet",
      "contact.form.email": "Email",
      "contact.form.phone": "Téléphone",
      "contact.form.phone.placeholder": "+32 ",
      "contact.form.address": "Adresse complète",
      "contact.form.requestType": "Type de demande",
      "contact.form.selectRequest": "Sélectionnez votre demande",
      "contact.form.energy": "Énergie",
      "contact.form.solar": "Panneaux solaires",
      "contact.form.coordination": "Chantier",
      "contact.form.energyType": "Type d'énergie (si applicable)",
      "contact.form.select": "Sélectionnez",
      "contact.form.electricityOnly": "Électricité uniquement",
      "contact.form.gasOnly": "Gaz uniquement",
      "contact.form.electricityGas": "Électricité + Gaz",
      "contact.form.annualConsumption": "Consommation annuelle (si connu)",
      "contact.form.panelsNumber": "Nombre de panneaux (si applicable)",
      "contact.form.panels1to5": "1 à 5 panneaux",
      "contact.form.panels6to10": "6 à 10 panneaux",
      "contact.form.panels11to15": "11 à 15 panneaux",
      "contact.form.panels16plus": "Plus de 16 panneaux",
      "contact.form.batteryDesired": "Batterie souhaitée (si applicable)",
      "contact.form.batteryYes": "Oui, avec batterie",
      "contact.form.batteryNo": "Non, sans batterie",
      "contact.form.batteryNotSure": "Pas encore décidé",
      "contact.form.additionalInfo": "Informations complémentaires",
      "contact.form.describeNeeds": "Décrivez vos besoins spécifiques...",
      "contact.form.submit": "Recevoir ma simulation",
      "contact.form.guarantee": "Simulation gratuite sous 24h - Service 100% gratuit et sans engagement",
      
      // Processus Section
      "processus.title": "Vos économies : 4 étapes ultra-simples",
      "processus.subtitle": "En 3 étapes simples, obtenez votre devis personnalisé",
      "processus.step1.title": "Rendez-vous",
      "processus.step1.description": "Choisissez votre créneau de 30 min.",
      "processus.step2.title": "Simulation",
      "processus.step2.description": "Calcul gratuit de vos économies potentielles.",
      "processus.step3.title": "Comparaison",
      "processus.step3.description": "Rapport des meilleures offres du marché.",
      "processus.step4.title": "Changement",
      "processus.step4.description": "Nous validons le contrat et gérons la transition.",
      
      // Panneaux Solaires Section
      "panneaux.title": "Votre installation solaire, 100 % rentable",
      "panneaux.subtitle": "Demandez votre offre : indiquez le nombre de panneaux souhaités, l'option batterie, votre adresse et vos coordonnées. Réponse sous 48 h. Optimisé pour les primes 2025 en Région bruxelloise.",
      "panneaux.avantage1.title": "Estimation gratuite",
      "panneaux.avantage1.description": "Calcul précis du nombre de panneaux et du besoin en batterie selon votre consommation",
      "panneaux.avantage2.title": "Rentabilité en < 7 ans",
      "panneaux.avantage2.description": "Calcul précis du retour sur investissement et des économies annuelles",
      "panneaux.avantage3.title": "Primes incluses",
      "panneaux.avantage3.description": "Dossier primes régionales pris en charge intégralement",
      "panneaux.cta": "Demander un devis solaire",
      
      // Coordination Chantiers Section
      "coordination.title": "Coordination raccordements & impétrants à Bruxelles",
      "coordination.subtitle": "Pour vos immeubles à appartements, nous gérons Sibelga, Vivaqua, les opérateurs télécom et le transfert des compteurs. Coordination impétrants Sibelga · Vivaqua · Proximus",
      "coordination.mission1.title": "Réunions de chantier",
      "coordination.mission1.description": "Organisation et coordination des réunions avec tous les intervenants",
      "coordination.mission2.title": "Dépôts Sibelga/Vivaqua",
      "coordination.mission2.description": "Dépôt et suivi des dossiers auprès des gestionnaires de réseau",
      "coordination.mission3.title": "Suivi planning",
      "coordination.mission3.description": "Suivi du planning et résolution des imprévus en temps réel, reporting Hebdo",
      "coordination.mission4.title": "Mises en service",
      "coordination.mission4.description": "Réception et mises en service pour chaque logement",
      "coordination.cta": "Obtenir un devis chantier",
      
      // Témoignages Section
      "temoignages.title": "Ils nous font confiance",
      "temoignages.subtitle": "Découvrez l'expérience de nos clients satisfaits",
      "temoignages.client1.name": "Pierre D.",
      "temoignages.client1.company": "Ixelles",
      "temoignages.client1.text": "Bravo Energy m'a permis d'économiser 30% sur ma facture en moins d'une heure !",
      "temoignages.client2.name": "Marie L.",
      "temoignages.client2.company": "Uccle",
      "temoignages.client2.text": "Service impeccable, conseils personnalisés et économies réelles. Je recommande vivement !",
      "temoignages.client3.name": "Jean-Marc V.",
      "temoignages.client3.company": "Woluwe",
      "temoignages.client3.text": "Changement de fournisseur sans stress, tout s'est fait automatiquement. Parfait !",
      "temoignages.readMore": "Lire plus...",
      "temoignages.readLess": "Lire moins...",
      "temoignages.client4.name": "Sophie K.",
      "temoignages.client4.company": "Etterbeek",
      "temoignages.client4.text": "Conseils clairs et chiffrés. J'ai compris en 10 minutes quelle offre choisir et combien j'allais économiser.",
      "temoignages.client5.name": "Nathalie P.",
      "temoignages.client5.company": "Schaerbeek",
      "temoignages.client5.text": "Equipe très réactive et sympathique. Démarches prises en charge de A à Z, zéro paperasse pour moi.",
      "temoignages.client6.name": "Thomas R.",
      "temoignages.client6.company": "Saint-Gilles",
      "temoignages.client6.text": "On a réduit la facture de ma PME de 22%. Rapport clair et comparatif transparent, je recommande sans hésiter.",
      
      // Header Hero Section
      "headerHero.title": "Boostez la performance énergétique de votre PME à Bruxelles & Brabant Flamand",
      "headerHero.subtitle": "Comparez. Économisez. Accompagnement gratuit & sans engagement.",
      "headerHero.cta": "Obtenir mon offre gratuite",
      "headerHero.callCta": "Appelez-nous",
      "headerHero.trust1": "Service 100% gratuit",
      "headerHero.trust2": "Sans engagement",
      "headerHero.trust3": "Résultats en 30 min",
      "headerHero.seo.title": "Bravo Énergie – Simulation gratuite pour PME Bruxelles & Brabant Flamand",
      "headerHero.seo.description": "Simulez vos économies d'électricité, gaz et solaire en 30 min. Service local, rapide et sans engagement.",
      "hero.seo.h1": "comparaison électricité Bruxelles • gaz Brabant flamand • audit énergie Brabant wallon",
      "hero.seo.alt": "illustration-comparaison-energie-bruxelles.svg",
      
      // Services
      "services.title": "Solutions énergie clés en main",
      "services.subtitle": "Solutions complètes pour optimiser vos coûts énergétiques",
      "services.card1.title": "Comparaison d'offres",
      "services.card1.description": "Analyse de votre profil, comparaison 25+ fournisseurs, rapport clair sous 24 h.",
      "services.card1.cta": "Lancer la comparaison",
      "services.card2.title": "Changement simplifié",
      "services.card2.description": "Signature électronique, suivi complet, zéro coupure.",
      "services.card2.cta": "Passer au meilleur tarif",
      "services.card3.title": "Audit annuel offert",
      "services.card3.description": "Audit de facture chaque année ; nous renégocions si une offre plus basse apparaît.",
      "services.card3.cta": "Planifier un audit",
      "services.card4.title": "Promos exclusives",
      "services.card4.description": "Accès à nos tarifs partenaires privés et réductions limitées.",
      "services.card4.cta": "Profiter des promos",
      
      // Avantages Section
      "avantages.title": "Ce que Bravo Energy fait gagner à votre portefeuille",
      "avantages.subtitle": "Des solutions simples et efficaces pour réduire vos factures d'énergie",
      "avantages.card1.title": "Économies garanties",
      "avantages.card1.description": "Jusqu'à 40% de réduction validée sur votre dernière facture, grâce à 25+ fournisseurs comparés en temps réel.",
      "avantages.card2.title": "Accompagnement expert",
      "avantages.card2.description": "Nous gérons résiliation, contrat et activation ; vous ne perdez pas une minute…et vous recevez un rapport PDF clair.",
      "avantages.card3.title": "Zéro jargon, 100% clair",
      "avantages.card3.description": "Un conseiller dédié répond 7j/7 par WhatsApp, mail ou téléphone.",
      "avantages.card4.title": "Local & réactif",
      "avantages.card4.description": "Rendez-vous sur site 48 h à Bruxelles & dans les Brabants, ou visio immédiate.",
      "whyChoose.advantage1.title": "Économies garanties",
      "whyChoose.advantage1.description": "– 15 % sur la facture en moyenne en 3 mois.",
      "whyChoose.advantage2.title": "Accompagnement expert",
      "whyChoose.advantage2.description": "Conseils 100 % clairs, sans jargon.",
      "whyChoose.advantage3.title": "Mobile-First & React",
      "whyChoose.advantage3.description": "UX optimisée pour 80 % d'utilisateurs sur mobile.",
      
      // Footer
      "footer.company": "Bravo Energy",
      "footer.description": "Votre partenaire pour optimiser votre consommation énergétique à Bruxelles."
    }
  },
  nl: {
    translation: {
      // Navigation
      "nav.home": "Home",
      "nav.services": "Diensten",
      "nav.panneaux": "Panelen",
      "nav.coordination": "Coördinatie",
      "nav.testimonials": "Klantenreviews",
      "nav.faq": "FAQ",
      "nav.contact": "Contact",
      "nav.blog": "Blog",
      "nav.language": "FR",
      "nav.cta": "Afspraak maken",

      // Blog Section
      "blog.title": "Onze Energie Blog",
      "blog.description": "Ontdek onze artikelen, tips en nieuws over zonne-energie en energiebesparing",
      "blog.meta.title": "Blog Zonne-energie en Besparingen",
      "blog.meta.description": "Expert artikelen en advies over zonne-energie, energiebesparing en innovaties in de sector",
      "blog.meta.keywords": "zonne-energie, zonnepanelen, energiebesparing, energie blog",
      "blog.readMore": "Lees meer",
      "blog.backToBlog": "Terug naar blog",
      "blog.share": "Delen",
      "blog.contactUs": "Contact opnemen",
      
      // Hero Section
      "hero.title": "Betaal minder voor uw energie in <span class=\"highlight\">Brussel</span>, in <span class=\"highlight\">Vlaams-Brabant</span> en <span class=\"highlight\">Waals-Brabant</span>",
      "hero.subtitle": "Tot <strong>40% besparingen</strong> : multi-leverancier vergelijking, overstap zonder onderbreking in 30 min.",
      "hero.cta": "Mijn gratis simulatie reserveren",
      "hero.guarantee1.title": "100% gratis",
      "hero.guarantee1.description": "Geen verborgen kosten",
      "hero.guarantee2.title": "Zonder verplichting",
      "hero.guarantee2.description": "Totale vrijheid",
      "hero.guarantee3.title": "Antwoord binnen 24u",
      "hero.guarantee3.description": "Reactieve service",
      "hero.stats.savings.percentage": "40%",
      "hero.stats.savings.label": "gemiddelde besparingen",
      "hero.stats.providers.number": "25+",
      "hero.stats.providers.label": "vergeleken leveranciers",
      "hero.stats.time.number": "30min",
      "hero.stats.time.label": "voor uw simulatie",
      "hero.scroll.text": "Ontdek onze diensten",
      
      // FAQ Section
      "faq.title": "FAQ Energiecontracten (België)",
      "faq.subtitle": "Alles wat u moet weten over onze diensten",
      "faq.q1.question": "Welke soorten energie biedt u aan ?",
      "faq.q1.answer": "Elektriciteit en aardgas voor particulieren en KMO's, inclusief 100% groene aanbiedingen.",
      "faq.q2.question": "Is de service echt 100% gratis ?",
      "faq.q2.answer": "Ja, onze service is volledig gratis. Wij rekenen geen verborgen kosten aan.",
      "faq.q3.question": "Zijn er verborgen kosten ?",
      "faq.q3.answer": "Nee, geen verborgen kosten. Onze service is 100% gratis, zonder verplichting.",
      "faq.q4.question": "Kan ik op elk moment van leverancier veranderen ?",
      "faq.q4.answer": "Ja, gratis en zonder onderbreking : de Belgische wet staat dit toe.",
      "faq.q5.question": "Wat is de termijn voor de overstap ?",
      "faq.q5.answer": "Meestal 2 tot 3 weken ; u kiest de startdatum.",
      "faq.q6.question": "Welke informatie moet ik verstrekken ?",
      "faq.q6.answer": "EAN-code, adres, indexstand, IBAN.",
      "faq.q7.question": "Vaste of variabele prijs ?",
      "faq.q7.answer": "Beide bestaan ; wij helpen u de meest voordelige formule te kiezen.",
      "faq.q8.question": "Kan ik op elk moment opzeggen ?",
      "faq.q8.answer": "Ja, zonder boete : het volstaat om elders in te schrijven.",
      "faq.q9.question": "Wat te doen bij verhuizing ?",
      "faq.q9.answer": "Laat het ons 10 dagen op voorhand weten ; wij transfereren of creëren een nieuw contract.",
      "faq.q10.question": "Biedt u groene elektriciteit aan ?",
      "faq.q10.answer": "Ja, afkomstig van gecertificeerde hernieuwbare bronnen.",
      "faq.q11.question": "Hoe bereik ik de klantenservice ?",
      "faq.q11.answer": "Telefoon : +32 2 123 45 67 – E-mail : contact@bravo-energy.be.",
      "faq.q12.question": "Wordt u erkend door de autoriteiten ?",
      "faq.q12.answer": "Ja : CREG, Brugel, CWAPE en VREG.",
      
      // Contact Section
      "contact.title": "Reserveer uw gratis afspraak",
      "contact.subtitle": "Brussel • Vlaams-Brabant • Waals-Brabant",
      "contact.subtitle2": "Visio of bezoek ter plaatse – antwoord binnen 24 uur.",
      "contact.info.title": "Snelle contact",
      "contact.info.description": "Een vraag ? Stuur ons een bericht en wij antwoorden snel.",
      "contact.email.label": "E-mail",
      "contact.phone.label": "Telefoon",
      "contact.address.label": "Adres",
      "contact.form.title": "Gratis simulatie",
      "contact.form.subtitle": "Vul dit formulier in om uw persoonlijke simulatie binnen 24 uur te ontvangen.",
      "contact.form.name": "Volledige naam",
      "contact.form.email": "E-mail",
      "contact.form.phone": "Telefoon",
      "contact.form.phone.placeholder": "+32 ",
      "contact.form.address": "Volledig adres",
      "contact.form.requestType": "Type aanvraag",
      "contact.form.selectRequest": "Selecteer uw aanvraag",
      "contact.form.energy": "Energie",
      "contact.form.solar": "Zonnepanelen",
      "contact.form.coordination": "Werf",
      "contact.form.energyType": "Type energie (indien van toepassing)",
      "contact.form.select": "Selecteer",
      "contact.form.electricityOnly": "Alleen elektriciteit",
      "contact.form.gasOnly": "Alleen gas",
      "contact.form.electricityGas": "Elektriciteit + Gas",
      "contact.form.annualConsumption": "Jaarlijks verbruik (indien bekend)",
      "contact.form.panelsNumber": "Aantal panelen (indien van toepassing)",
      "contact.form.panels1to5": "1 tot 5 panelen",
      "contact.form.panels6to10": "6 tot 10 panelen",
      "contact.form.panels11to15": "11 tot 15 panelen",
      "contact.form.panels16plus": "Meer dan 16 panelen",
      "contact.form.batteryDesired": "Gewenste batterij (indien van toepassing)",
      "contact.form.batteryYes": "Ja, met batterij",
      "contact.form.batteryNo": "Nee, zonder batterij",
      "contact.form.batteryNotSure": "Nog niet beslist",
      "contact.form.additionalInfo": "Aanvullende informatie",
      "contact.form.describeNeeds": "Beschrijf uw specifieke behoeften...",
      "contact.form.submit": "Ontvang mijn simulatie",
      "contact.form.guarantee": "Gratis simulatie binnen 24u - Service 100% gratis en zonder verplichting",
      
      // Processus Section
      "processus.title": "Uw besparingen : 4 ultrazakelijke stappen",
      "processus.subtitle": "In 3 eenvoudige stappen krijgt u uw persoonlijke offerte",
      "processus.step1.title": "Afspraak",
      "processus.step1.description": "Kies uw tijdslot van 30 min.",
      "processus.step2.title": "Simulatie",
      "processus.step2.description": "Gratis berekening van uw potentiële besparingen.",
      "processus.step3.title": "Vergelijking",
      "processus.step3.description": "Rapport van de beste aanbiedingen op de markt.",
      "processus.step4.title": "Wijziging",
      "processus.step4.description": "Wij valideren het contract en beheren de overgang.",
      
      // Panneaux Solaires Section
      "panneaux.title": "Uw zonne-installatie, 100 % rendabel",
      "panneaux.subtitle": "Vraag uw offerte : geef het gewenste aantal panelen, batterijoptie, uw adres en contactgegevens. Antwoord binnen 48 uur. Geoptimaliseerd voor 2025 premies in het Brussels Gewest.",
      "panneaux.avantage1.title": "Gratis schatting",
      "panneaux.avantage1.description": "Nauwkeurige berekening van het aantal panelen en batterijbehoefte volgens uw verbruik",
      "panneaux.avantage2.title": "Rendabiliteit in < 7 jaar",
      "panneaux.avantage2.description": "Nauwkeurige berekening van return on investment en jaarlijkse besparingen",
      "panneaux.avantage3.title": "Premies inbegrepen",
      "panneaux.avantage3.description": "Dossier regionale premies volledig verzorgd",
      "panneaux.cta": "Zonne-offerte aanvragen",
      
      // Coordination Chantiers Section
      "coordination.title": "Coördinatie aansluitingen & vergunningen in Brussel",
      "coordination.subtitle": "Voor uw appartementsgebouwen beheren wij Sibelga, Vivaqua, telecomoperators en meteroverdracht. Coördinatie vergunningen Sibelga · Vivaqua · Proximus",
      "coordination.mission1.title": "Werfvergaderingen",
      "coordination.mission1.description": "Organisatie en coördinatie van vergaderingen met alle betrokkenen",
      "coordination.mission2.title": "Deposito's Sibelga/Vivaqua",
      "coordination.mission2.description": "Deposito en opvolging van dossiers bij netwerkbeheerders",
      "coordination.mission3.title": "Planning opvolging",
      "coordination.mission3.description": "Planning opvolging en real-time oplossing van onvoorziene gebeurtenissen, wekelijks rapport",
      "coordination.mission4.title": "Inbedrijfstellingen",
      "coordination.mission4.description": "Receptie en inbedrijfstelling voor elke woning",
      "coordination.cta": "Werf offerte krijgen",
      
      // Témoignages Section
      "temoignages.title": "Ze vertrouwen ons",
      "temoignages.subtitle": "Ontdek de ervaring van onze tevreden klanten",
      "temoignages.client1.name": "Pierre D.",
      "temoignages.client1.company": "Elsene",
      "temoignages.client1.text": "Bravo Energy heeft me 30% besparingen op mijn factuur opgeleverd in minder dan een uur !",
      "temoignages.client2.name": "Marie L.",
      "temoignages.client2.company": "Ukkel",
      "temoignages.client2.text": "Impeccabele service, persoonlijk advies en echte besparingen. Ik beveel het ten zeerste aan !",
      "temoignages.client3.name": "Jean-Marc V.",
      "temoignages.client3.company": "Sint-Lambrechts-Woluwe",
      "temoignages.client3.text": "Leverancierswissel zonder stress, alles ging automatisch. Perfect !",
      "temoignages.readMore": "Lees meer...",
      "temoignages.readLess": "Lees minder...",
      "temoignages.client4.name": "Sophie K.",
      "temoignages.client4.company": "Etterbeek",
      "temoignages.client4.text": "Duidelijk en cijfermatig advies. In 10 minuten wist ik welk aanbod te kiezen en hoeveel ik zou besparen.",
      "temoignages.client5.name": "Nathalie P.",
      "temoignages.client5.company": "Schaarbeek",
      "temoignages.client5.text": "Heel snel en vriendelijk team. Alle stappen werden geregeld, geen papierwerk voor mij.",
      "temoignages.client6.name": "Thomas R.",
      "temoignages.client6.company": "Sint-Gillis",
      "temoignages.client6.text": "We hebben de factuur van mijn KMO met 22% verlaagd. Duidelijk rapport en transparante vergelijking. Aanrader.",
      
      // Header Hero Section
      "headerHero.title": "Verhoog de energieprestaties van uw KMO in Brussel & Vlaams-Brabant",
      "headerHero.subtitle": "Vergelijk. Bespaar. Gratis begeleiding & zonder verplichting.",
      "headerHero.cta": "Krijg mijn gratis offerte",
      "headerHero.callCta": "Bel ons",
      "headerHero.trust1": "100% gratis service",
      "headerHero.trust2": "Zonder verplichting",
      "headerHero.trust3": "Resultaten in 30 min",
      "headerHero.seo.title": "Bravo Energie – Gratis simulatie voor KMO Brussel & Vlaams-Brabant",
      "headerHero.seo.description": "Simuleer uw elektriciteits-, gas- en zonne-energiebesparingen in 30 min. Lokale, snelle service zonder verplichting.",
      "hero.seo.h1": "elektriciteit vergelijking Brussel • gas Vlaams-Brabant • energie audit Waals-Brabant",
      "hero.seo.alt": "illustration-comparaison-energie-bruxelles.svg",
      
      // Services
      "services.title": "Energie-oplossingen op maat",
      "services.subtitle": "Volledige oplossingen om uw energiekosten te optimaliseren",
      "services.card1.title": "Offertevergelijking",
      "services.card1.description": "Analyse van uw profiel, vergelijking 25+ leveranciers, duidelijk rapport binnen 24 uur.",
      "services.card1.cta": "Vergelijking starten",
      "services.card2.title": "Vereenvoudigde overstap",
      "services.card2.description": "Elektronische ondertekening, volledige opvolging, nul onderbreking.",
      "services.card2.cta": "Overstappen naar beste tarief",
      "services.card3.title": "Gratis jaarlijkse audit",
      "services.card3.description": "Factuuraudit elk jaar ; wij onderhandelen opnieuw als een lagere aanbieding verschijnt.",
      "services.card3.cta": "Audit plannen",
      "services.card4.title": "Exclusieve promoties",
      "services.card4.description": "Toegang tot onze privé partnerprijzen en beperkte kortingen.",
      "services.card4.cta": "Profiteren van promoties",
      
      // Avantages Section
      "avantages.title": "Wat Bravo Energy uw portefeuille bespaart",
      "avantages.subtitle": "Eenvoudige en effectieve oplossingen om uw energierekeningen te verlagen",
      "avantages.card1.title": "Gegarandeerde besparingen",
      "avantages.card1.description": "Tot 40% gereduceerde validatie op uw laatste factuur, dankzij 25+ leveranciers in real-time vergeleken.",
      "avantages.card2.title": "Deskundige begeleiding",
      "avantages.card2.description": "Wij regelen opzegging, contract en activering; u verliest geen minuut…en u ontvangt een duidelijk PDF-rapport.",
      "avantages.card3.title": "Geen jargon, 100% duidelijk",
      "avantages.card3.description": "Een toegewijde adviseur antwoordt 7d/7 via WhatsApp, e-mail of telefoon.",
      "avantages.card4.title": "Lokaal & reactief",
      "avantages.card4.description": "Afspraak ter plaatse 48 uur in Brussel & de Brabanten, of directe visio.",
      "whyChoose.advantage1.title": "Gegarandeerde besparingen",
      "whyChoose.advantage1.description": "– 15% op de factuur gemiddeld in 3 maanden.",
      "whyChoose.advantage2.title": "Deskundige begeleiding",
      "whyChoose.advantage2.description": "100% duidelijk advies, zonder jargon.",
      "whyChoose.advantage3.title": "Mobile-First & React",
      "whyChoose.advantage3.description": "UX geoptimaliseerd voor 80% gebruikers op mobiel.",
      
      // Footer
      "footer.company": "Bravo Energy",
      "footer.description": "Uw partner voor het optimaliseren van uw energieverbruik in Brussel."
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    debug: false,

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    }
  });

export default i18n;